import React from 'react'
import { useEntityNavigate as useNavigate } from '../../../navigation/navigation'
import Icon from '../../../components/Icon'
import { Button } from '../../../components/ui'
import { getContractShortLabel } from '../stageTableGrouping'

function getContractShortLabelFromItem(item) {
  return getContractShortLabel(item.contract_number || item.stage_id || '-')
}

function EmployeeAllocationBoard({
  columns,
  stages,
  loading,
  canEdit,
  updatingStageId,
  menuStageId,
  draggedStageId,
  statusActions,
  preventCardClickRef,
  onOpenAdd,
  onMenuChange,
  onStatusChange,
  onDragStart,
  onDragEnd,
  onDrop,
  formatDate,
}) {
  const navigate = useNavigate()

  return (
    <div
      id="allocation"
      role="tabpanel"
      className="employee-allocation-panel"
      aria-labelledby="employee-main-tab-allocation"
    >
      <div className="employee-allocation-toolbar">
        <h2 aria-label="Доска">Доска проектов</h2>
        {canEdit && (
          <Button type="button" variant="primary" size="sm" onClick={onOpenAdd}>
            <Icon name="plus" size={16} />
            <span>Добавить проект</span>
          </Button>
        )}
      </div>
      {loading ? (
        <p className="info-note">Загрузка стадий...</p>
      ) : stages.length === 0 ? (
        <p className="employee-section-placeholder">Нет назначенных стадий.</p>
      ) : (
        <div className="employee-allocation-board">
          {columns.map((column) => {
            const columnItems = stages.filter((item) => (item.work_status || 'new') === column.id)
            return (
              <div
                key={column.id}
                className={`employee-allocation-column ${draggedStageId ? 'employee-allocation-column-droppable' : ''}`}
                onDragOver={(event) => event.preventDefault()}
                onDrop={() => onDrop(column.id)}
              >
                <div className="employee-allocation-column-head">
                  <h3>{column.title}</h3>
                  <span className="employee-allocation-count">{columnItems.length}</span>
                </div>
                {columnItems.length === 0 ? (
                  <p className="employee-allocation-empty">
                    {column.id === 'in_progress'
                      ? 'Отметь стадии в разделе «Что ещё можешь заработать»'
                      : 'Нет стадий'}
                  </p>
                ) : (
                  <div className="employee-allocation-cards">
                    {columnItems.map((item) => (
                      <div
                        key={item.stage_id}
                        className="employee-allocation-card ui-card ui-card-hover"
                        onClick={() => {
                          if (preventCardClickRef.current) {
                            preventCardClickRef.current = false
                            return
                          }
                          const target = item.object_stage_id || item.stage_id
                          if (item.object_stage_id) {
                            navigate(`/company/budgets/${encodeURIComponent(target)}`)
                            return
                          }
                          navigate(`/stage/${encodeURIComponent(target)}`)
                        }}
                        draggable={canEdit && updatingStageId !== item.stage_id}
                        onDragStart={(event) => onDragStart(event, item.stage_id)}
                        onDragEnd={onDragEnd}
                      >
                        <div className="employee-allocation-card-head">
                          <span className="employee-allocation-card-stage">
                            {item.stage_display_type || item.stage_type || 'Стадия'} · {getContractShortLabelFromItem(item)}
                          </span>
                          {canEdit && (
                            <div className="employee-allocation-menu-wrap" onClick={(event) => event.stopPropagation()}>
                              <button
                                type="button"
                                className="employee-allocation-menu-button"
                                aria-label={`Меню стадии ${item.stage_id}`}
                                onClick={() => onMenuChange(menuStageId === item.stage_id ? null : item.stage_id)}
                                disabled={updatingStageId === item.stage_id}
                              >
                                <span aria-hidden>...</span>
                              </button>
                              {menuStageId === item.stage_id && (
                                <div className="employee-allocation-menu">
                                  {statusActions.map((action) => {
                                    const currentStatus = item.work_status || 'new'
                                    return (
                                      <button
                                        key={action.status}
                                        type="button"
                                        className="employee-allocation-menu-item"
                                        onClick={() => {
                                          onMenuChange(null)
                                          if (currentStatus !== action.status) onStatusChange(item.stage_id, action.status)
                                        }}
                                        disabled={currentStatus === action.status || updatingStageId === item.stage_id}
                                      >
                                        {action.label}
                                      </button>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="employee-allocation-card-title">{item.stage_object || item.object_name || '-'}</div>
                        {item.client_name ? (
                          <div className="employee-allocation-card-object">{item.client_name}</div>
                        ) : null}
                        <div className="employee-allocation-card-meta">
                          <span className="employee-allocation-card-date">
                            <Icon name="calendar" size={13} aria-hidden />
                            {formatDate(item.planned_date, item.fact_date)}
                          </span>
                          {item.income_amount != null && (
                            <span className="employee-allocation-card-amount">
                              {new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Number(item.income_amount || 0))} ₽
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default EmployeeAllocationBoard
